import { useMutation } from '@tanstack/react-query'

import type {
  CreateReservationRequest,
  CreateReservationResponse,
} from '../../../types/reservation.js'

import { apiClient } from '../../../lib/client.js'

export const useCreateReservationMutation = () =>
  useMutation({
    mutationFn: async (request: CreateReservationRequest) => {
      const response = await apiClient.client.post<CreateReservationResponse>(
        '/reservation',
        request
      )
      return response.data
    },
  })
